import $ from 'jquery';

export default {
    // posts(url) {
    //     return {
    //         getOne: ({ id }) => axios.get(`${url}/${id}`),
    //         getAll: () => axios.get(url),
    //         update: (toUpdate) => axios.put(url, toUpdate),
    //         create: (toCreate) => axios.put(url, toCreate),
    //         delete: ({ id }) => axios.delete(`${url}/${id}`),
    //     }
    // },
    mget(url) {
        return $.get({
            url: url,
            dataType: 'json',
            beforeSend: function (xhr) {
                let token = localStorage.getItem('merchant_token');
                if (token !== null || token !== undefined) {
                    xhr.setRequestHeader("Authorization", token);
                    xhr.setRequestHeader("Accept", "application/json");
                }
            },
        });
    },
    mpost(url, data) {
        return $.post({
            url: url,
            data: data,
            dataType: 'json',
            beforeSend: function (xhr) {
                let token = localStorage.getItem('merchant_token');
                if (token !== null || token !== undefined) {
                    xhr.setRequestHeader("Authorization", token);
                    xhr.setRequestHeader("Accept", "application/json");
                }
            },
        });
    },
}

export function handleAjaxError(xhr){
    var isDialogAlertDismissed = true
    if (xhr.status == 401) {
        window.location.reload()
    }
    else if(xhr.responseJSON && xhr.responseJSON.message){
        if(isDialogAlertDismissed){
            isDialogAlertDismissed = false
            alert(xhr.responseJSON.message)
        }
        isDialogAlertDismissed = true
    }
    if(xhr.status == 401){
        windows.location.reload()
        return true
    }

    return false
}